import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ActiveIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22ZM12 4C7.589 4 4 7.589 4 12C4 16.411 7.589 20 12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ActiveIcon.propTypes = {
  sx: PropTypes.object,
};

export default ActiveIcon;
